// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ekqur","content":"styles_content__1sgsC"};